
interface TagType {
   TypeId: string,
   TypeName: string,
   TypeIdChild: string,
   TypeIdParent: string
}



var TagTypes: {[id: string]: TagType} = {
  Tag:         {TypeId: 'Tag',         TypeName: 'Tag',          TypeIdChild: undefined,     TypeIdParent:'TagGroup' },
  TagGroup:    {TypeId: 'TagGroup',    TypeName: 'Tag Group',    TypeIdChild: 'Tag',         TypeIdParent:'TagCategory' },
  TagCategory: {TypeId: 'TagCategory', TypeName: 'Tag Category', TypeIdChild: 'TagGroup',    TypeIdParent:'TagUsage' },
  TagUsage:    {TypeId: 'TagUsage',    TypeName: 'Tag Usage',    TypeIdChild: 'TagCategory', TypeIdParent: undefined },
}

export { TagType, TagTypes }

